
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useLanguage } from "@/contexts/LanguageContext";
import { RocketIcon } from "lucide-react";

interface CreateCampaignCardProps {
  onCreateCampaign: () => void;
}

export const CreateCampaignCard = ({ onCreateCampaign }: CreateCampaignCardProps) => {
  const { t } = useLanguage();
  
  return (
    <Card className="bg-gradient-to-br from-primary/10 via-primary/5 to-card border-primary/20 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
      <CardHeader className="text-center">
        <CardTitle className="flex flex-col items-center gap-2 text-primary whitespace-nowrap">
          <RocketIcon className="h-8 w-8 mb-1" />
          <span>{t('newCampaign')}</span>
        </CardTitle>
        <CardDescription className="text-base font-medium">
          {t('startFreshCampaign')}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm leading-relaxed text-center">
          {t('createCampaignCard')}
        </p>
      </CardContent>
      <CardFooter>
        <Button 
          size="lg" 
          onClick={onCreateCampaign}
          className="w-full bg-primary text-white hover:bg-primary/90 font-medium"
        >
          {t('createCampaign')}
        </Button>
      </CardFooter>
    </Card>
  );
};
